export default class Accordeon {
    constructor(element) {
        this.element = element;
        this.groups = this.element.querySelectorAll('.accordeon-group');
        this.init();
    }

    init() {
        this.groups.forEach(group => {
            const content = group.querySelector('.accordeon-content');

            group.addEventListener('click', () => {
                const isOpen = group.classList.contains('open');

                this.groups.forEach(g => {
                    g.classList.remove('open');
                    const c = g.querySelector('.accordeon-content');
                    if (c) c.style.maxHeight = null;
                });

                if (!isOpen) {
                    group.classList.add('open');
                    if (content) {
                        content.style.maxHeight = content.scrollHeight + "px";
                    }
                }
            });
        });
    }
}
